import ReactGA from 'react-ga4';

export const initGA = () => {
  ReactGA.initialize('G-Y24V41GG22');
};

/**
 * Send a page-view hit to GA4.
 * Passing `title` ensures GA's "Pages and screens" report groups
 * entries by human-readable module name instead of bare paths.
 *
 * @param {string} path   - e.g. '/qrcodegenerator'
 * @param {string} [title] - e.g. 'PixelWizard - QR Code Generator'
 */
export const sendPageView = (path, title) => {
  ReactGA.send({
    hitType: 'pageview',
    page: path,
    ...(title ? { title } : {}),
  });
};

export const sendEvent = (category, action, label) => {
  ReactGA.event({
    category,
    action,
    label,
  });
};
